module.exports = __webpack_public_path__ + "img/profilo_careers.3b215e46.png";